import { z } from "zod";

const CardResponseStatusType = z.enum(["valida", "rechazada"]);

const CardResponseSchema = z
  .object({
    id_transaccion: z
      .union([z.string(), z.number()])
      .nullish()
      .transform((v) => (v == null ? v : String(v))),
    codigo_rastreo: z.string(),
    estatus: CardResponseStatusType,
  })
  .transform((api) => ({
    trackingCode: api.codigo_rastreo,
    transactionId: api.id_transaccion,
    status: api.estatus,
  }));

type CardResponse = z.infer<typeof CardResponseSchema>;

export { CardResponseSchema, type CardResponse };
